import {
  DEFAULT_BIG_IMAGE_TWO_COLUMNS_TRANSFORMATIONS,
  DEFAULT_IMAGE_TWO_COLUMNS_TRANSFORMATIONS,
  PictureTransformations,
} from 'common/components';
import { CONSTRUCTION_HOUSES_LANDING_NAME } from '../../construction-houses-constants';

export type ConstructionHousesGalleryStructure = {
  alt: string;
  name: string;
  src: string;
  srcSmall: string;
  transformations?: PictureTransformations;
};

const CONSTRUCTION_HOUSES_GALLERY_NAME_LIST = [
  'Тёплый пол',
  'Металлическая кровля',
  'Металлический штакетник',
  'Деревянная межэтажная лестница',
  'Входная дверь в частном доме',
  'Система фильтрации',
  'Противовзломные окна',
];

export const CONSTRUCTION_HOUSES_GALLERY: ConstructionHousesGalleryStructure[] = CONSTRUCTION_HOUSES_GALLERY_NAME_LIST.map(
  (name: string, index: number) => {
    const imageName = index + 1;

    const baseInfo = {
      alt: name,
      name: `${imageName}.jpg`,
      src: `${CONSTRUCTION_HOUSES_LANDING_NAME}/gallery-popup/${imageName}.jpg/${imageName}.jpg`,
      srcSmall: `${CONSTRUCTION_HOUSES_LANDING_NAME}/gallery/${imageName}.jpg/${imageName}.jpg`,
      transformations: DEFAULT_IMAGE_TWO_COLUMNS_TRANSFORMATIONS,
    };

    if (index === 4) {
      return {
        ...baseInfo,
        transformations: DEFAULT_BIG_IMAGE_TWO_COLUMNS_TRANSFORMATIONS,
      };
    }

    return baseInfo;
  }
);
